export const arsaBannerExternalLinks = {
  youtubeLink: "https://www.youtube.com/watch?v=DYsBJ8GWiko",
  imageSource: "https://imgvisilabsnet.azureedge.net/banner/uploaded_images/271_909_20240125110800173.png",
};
